export const errors = {

};

export const errorsCodes = {
  UNAUTHORIZED_CODE: 401,
  SERVER_ERROR: 500,
};

